import { Row, Col } from 'react-bootstrap';
import { useLabels } from '../../functions';
import { formatPrice } from './functions';


const CartSection = ({ title, items, total }) => {
  const labels = useLabels();
  const totalFormatted = Number(total).toFixed(2);

  return (
    <div className="section">
      <Row>
        <Col>
          <h4>{title}</h4>
        </Col>
      </Row>
      <div className="section-items">
        {items.map((item, idx) => {
          const isCredit = item.Price < 0;
          const className = isCredit ? 'item credit' : 'item';
          return (
            <Row key={`${item.Item}-${idx}`}>
              <Col xs={8} sm={6} md={8}>
                <span className={className}>{item.Item}</span>
              </Col>
              <Col xs={4} sm={6} md={4}>
                <span className={className}>{formatPrice(item.Price)}</span>
              </Col>
            </Row>
          );
        })}
      </div>
      <div className="section-total">
        <Row>
          <Col sm={6} md={8}>
            <span>
              {labels.monthlyBill}
              <br />
              <span>({labels.notTaxesIncluded})</span>
            </span>
          </Col>
          <Col sm={6} md={4}>
            <span>{formatPrice(totalFormatted)}</span>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CartSection;
